import { render, staticRenderFns } from "./BatchActionEditProductsFilters.vue?vue&type=template&id=b157be3c"
import script from "./BatchActionEditProductsFilters.vue?vue&type=script&lang=js"
export * from "./BatchActionEditProductsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports